import { LoadingComponent, PrivatePage } from "components";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactElement, useCallback, useEffect } from "react";

import { CityContextProvider } from "../contexts/city-context-provider";
import { RoleType } from "@/store/auth/auth.type";
import { auth0Config } from "../configs/auth-config";
import { checkPermission } from "../helper/utils";
import { routes } from "./constants";
import { showNotification } from "components/notification";
import { useAuth0 } from "@auth0/auth0-react";

const matchRoute = (routePath: string, currentPath: string): boolean => {
  // Convert route pattern to regex
  // "/user-detail/:id" becomes "^/user-detail/[^/]+$"
  const pattern = routePath.replace(/:\w+/g, "[^/]+").replace(/\//g, "\\/");

  const regex = new RegExp(`^${pattern}$`);
  return regex.test(currentPath);
};

export default function MiddleWare(): ReactElement {
  const { user, error, isLoading } = useAuth0();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const validateRole = useCallback(() => {
    if (!user) {
      return;
    }
    const userRoles = user[`${auth0Config.namespace}/roles`] as RoleType[];
    const listRoute = Object.values(routes);

    const matchedRoute = listRoute.find((route) => matchRoute(route.path, pathname));

    const hasPermission = checkPermission(matchedRoute.roles, userRoles);
    if (!hasPermission) {
      showNotification({
        variant: "error",
        message: `You are logged in as a ${userRoles.join(", ") || "None"}. Please contact our administrator`,
      });
      navigate(routes.error.path);
    }
  }, [user, navigate, pathname]);

  useEffect(() => {
    if (error) {
      navigate(routes.error.path);
      return;
    }
    validateRole();
  }, [error, validateRole, navigate]);

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <CityContextProvider>
      <PrivatePage component={Outlet} />
    </CityContextProvider>
  );
}
